<template>
  <div id="app">
    <pagevue></pagevue>
  </div>
</template>

<script>
import pagevue from './components/pagevue.vue'

export default {
  components: {
    pagevue
  }
}
</script>
<style scoped>
  #app {
    height:100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue